const i = [
  ["OC", "/"],
  ["US", "us/"],
  ["DE", "de/"],
  ["CO", "co/"],
  ["AU", "au/"],
  ["NZ", "nz/"],
  ["IN", "in/"],
  ["PT", "pt/"],
  ["ZA", "za/"],
  ["KE", "ke/"],
  ["NG", "ng/"],
  ["NL", "nl/"],
  ["FR", "fr/"],
  ["SE", "se/"],
  ["SM", "sm/"],
  ["CX", "cx/"],
  ["CA", "ca/"],
  ["ES", "es/"],
  ["IT", "it/"],
  ["BR", "br/"],
  ["GZ", "/"],
  ["WS", "/"]
];
function u(e, n) {
  const r = i.find(([s]) => s === e);
  if (!r) return n ? "/" : "";
  const t = r[1];
  return t === "/" ? n ? "/" : "" : `/${t.replace(/\/$/, "")}`;
}
function c(e) {
  return u(e, !1);
}
function f(e) {
  return u(e, !0);
}
function a(e, n) {
  const r = c(n);
  return r && (e === r || e.startsWith(`${r}/`)) ? e.slice(r.length) || "/" : e;
}
export {
  c as a,
  i as b,
  f as g,
  a as r
};
